/**
 * A domain state as a pill with its word: "Approved", "In review", "Removed". It takes the
 * `{ label, tone }` that `@lattice/format` builds from a state, never the raw state, so a database
 * word such as `in_review` cannot reach a screen. It is not a live region, so a table of fifty
 * orders does not announce fifty statuses.
 */
import { Badge } from "./Badge.tsx";
import type { BadgeTone } from "./Badge.tsx";

export interface StatusPillValue {
  readonly label: string;
  readonly tone: BadgeTone;
}

export function StatusPill({
  pill,
  testId,
}: {
  readonly pill: StatusPillValue;
  readonly testId?: string;
}) {
  return (
    <Badge tone={pill.tone} dot {...(testId === undefined ? {} : { testId })}>
      {pill.label}
    </Badge>
  );
}
